import { sendInquiry } from "../utils/sendInquiry";
import { toast } from "react-toastify";

/**
 * handleApply
 *
 * 指定したtype・id・csrfTokenで問い合わせAPIを実行し、
 * 結果に応じて成功・失敗のトースト通知を表示する共通関数です。
 *
 * @param {Object} params
 * @param {string} params.type      - "projects" などAPI種別
 * @param {number|string} params.id - 問い合わせ先ID
 * @param {string} params.csrfToken - CSRFトークン
 */
export const handleApply = async ({ type, id, csrfToken }) => {
  // 問い合わせAPIを実行
  const result = await sendInquiry({ type, id, csrfToken });

  // 成功時：成功トーストを表示
  if (result.success) {
    toast.success("企業に問い合わせメールを\n送りました。", {
      style: { whiteSpace: "pre-line" },
    });
  } else {
    // 失敗時：エラートーストを表示
    toast.error(result.error || "送信に失敗しました。");
  }
};
